<template>
	<n-config-provider :theme="darkTheme" :theme-overrides="themeOverride">
		<n-message-provider>
			<n-notification-provider>
				<router-view />
			</n-notification-provider>
		</n-message-provider>
	</n-config-provider>
</template>

<script setup>
import { darkTheme } from "naive-ui"

const themeOverride = {
	common: {
		fontSizeMedium: "18px",
	},
	Timeline: {
		titleFontSizeMedium: "16px",
		contentFontSize: "16px",
	},
	Card: {
		paddingMedium: "10px 24px 10px",
	},
	Notification: {
		iconColor: "240, 240, 240",
		iconColorSuccess: "42, 148, 125",
		iconColorInfo: "56, 137, 197",
		iconColorWarning: "240, 138, 0",
		iconColorError: "208, 58, 82",
	},
	Popover: {
		padding: "",
	},
}
</script>
